module.exports = __webpack_public_path__ + "static/media/manager.a7f3821e.svg";